module.exports = __webpack_public_path__ + "static/help-img-4-8ab93e054a62fd7b057f8b3a7fa17cc3.svg";